<template>
  <div class="drivers__chart-wrapper">
    <component :is="chartNode.type" :value="chartNode" v-if="chartNode" />
  </div>
</template>

<script>
// Components
import { HorizontalBarChart, HorizontalLineChart, PriorityMatrix } from '@/pigeondoc/wrapper';

export default {
  name: 'DriversChart',
  components: {
    HorizontalBarChart,
    HorizontalLineChart,
    PriorityMatrix,
  },
  props: {
    chartNode: {
      type: Object,
      default: () => {},
    },
    type: {
      // todo replacing with the type in the chartnode, like performance charts
      type: String,
      default: () => '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
